import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    verifyTable: {
        marginTop: 25,
        fontSize: 12,
        '& th': {
            fontWeight: 'bold',
            backgroundColor: theme.palette.grey[100],
            textAlign: 'left',
        },
        '& td': {
            textAlign: 'left',
            verticalAlign: 'top',
        },
        '& > tbody > tr:nth-child(odd)': {
            backgroundColor: '#ffffff !important',
        },
        '& > tbody > tr:nth-child(even)': {
            backgroundColor: '#f5f5f5 !important',
        },
    },
    metricsTable: {
        '& td': {
            padding: theme.spacing(0.5, 1),
            border: 'none',
            textAlign: 'left',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
        },
        '& tr:nth-child(odd)': {
            backgroundColor: '#ffffff !important',
        },
        '& tr:nth-child(even)': {
            backgroundColor: '#f5f5f5 !important',
        },
    },
    pulseNameCell: {
        minWidth: 250,
    },
    logContainer: {
        marginTop: theme.spacing(1),
    },
    logToggle: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        color: theme.palette.primary.main,
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    logContent: {
        maxHeight: 400,
        overflow: 'auto',
        backgroundColor: theme.palette.grey[50],
        padding: theme.spacing(1),
        fontFamily: 'monospace',
        fontSize: '0.85rem',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
    },
    httpLink: {
        cursor: 'pointer',
        color: theme.palette.primary.main,
        textDecoration: 'underline',
    },
}));

export default useStyles;
